import { render, staticRenderFns } from "./CategoriesPills.vue?vue&type=template&id=2aabf94e&scoped=true&"
import script from "./CategoriesPills.vue?vue&type=script&lang=js&"
export * from "./CategoriesPills.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesPills.vue?vue&type=style&index=0&id=2aabf94e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aabf94e",
  null
  
)

export default component.exports